import dayjs from "dayjs";

export const baseColumns = [
  { field: "service_type", label: "Service Type" },
  { field: "category", label: "Category" },
  { field: "unit", label: "Unit" },
  { field: "price", label: "Price" },
  { field: "description", label: "Description" },
  { field: "action", label: "Action" },
];
export const washAndFoldColumns = [
  { field: "service_type", label: "Service Type" },
  { field: "category", label: "Category" },
  { field: "unit", label: "Unit" },
  { field: "price", label: "Price" },
  { field: "lbs", label: "LBS" },
  { field: "description", label: "Description" },
  { field: "action", label: "Action" },
];

export const tailoringColumns = [
  { field: "service_type", label: "Service Type" },
  { field: "category", label: "Category" },
  { field: "clothType", label: "Cloth" },
  { field: "tailoringType", label: "Tailoring Type" },
  { field: "unit", label: "Unit" },
  { field: "price", label: "Price" },
  { field: "description", label: "Description" },
  { field: "action", label: "Action" },
];

export const clothColumns = [
  { field: "service_type", label: "Service Type" },
  { field: "category", label: "Category" },
  { field: "clothType", label: "Cloth" },
  { field: "unit", label: "Unit" },
  { field: "price", label: "Price" },
  { field: "description", label: "Description" },
  { field: "action", label: "Action" },
];

export const serviceRows = [
  {
    id: "1",
    service_name: "Washing",
    category: "Gents Wear",
    unit: 1,
    price: "$50",
    type: "Per Unit",
    description: "Standard washing for gents wear",
  },
  {
    id: "2",
    service_name: "Dry Cleaning",
    category: "Lady's Wear",
    unit: 2,
    price: "$120",
    type: "Per Unit",
    description: "Delicate dry cleaning for ladies wear",
  },
  {
    id: "3",
    service_name: "Stitching",
    category: "Kids Wear",
    unit: 1,
    price: "$200",
    type: "Fixed",
    description: "Basic stitching service for kids clothes",
  },
  {
    id: "4",
    service_name: "Ironing",
    category: "Kids Wear",
    unit: 1,
    price: "$30",
    type: "Per Unit",
    description: "Wrinkle-free ironing",
  },
  {
    id: "5",
    service_name: "Wash & Iron",
    category: "Kids Wear",
    unit: 4,
    price: "$70",
    type: "Per Unit",
    description: "Complete washing and ironing service",
  },
  {
    id: "6",
    service_name: "Saree Rolling",
    category: "Lady's Wear",
    unit: 1,
    price: "$100",
    type: "Per Unit",
    description: "Roll press for silk sarees",
  },
  {
    id: "7",
    service_name: "Curtain Cleaning",
    category: "Household",
    unit: 3,
    price: "$250",
    type: "Per Kg",
    description: "Deep cleaning for curtains",
  },
  {
    id: "8",
    service_name: "Blazer Dry Clean",
    category: "Gents Wear",
    unit: 1,
    price: "$180",
    type: "Per Item",
    description: "Premium dry clean for blazers",
  },
  {
    id: "9",
    service_name: "Blanket Wash",
    category: "Household",
    unit: 1,
    price: "$150",
    type: "Per Piece",
    description: "Machine wash for thick blankets",
  },
  {
    id: "10",
    service_name: "Shoe Cleaning",
    category: "Accessories",
    unit: 1,
    price: "$90",
    type: "Per Pair",
    description: "Shoe wash and polish",
  },
  {
    id: "11",
    service_name: "Carpet Cleaning",
    category: "Household",
    unit: 2,
    price: "$350",
    type: "Per Sq.Ft",
    description: "Dry and wet carpet cleaning",
  },
  {
    id: "12",
    service_name: "Pillow Wash",
    category: "Household",
    unit: 2,
    price: "$80",
    type: "Per Pair",
    description: "Wash and deodorize pillows",
  },
  {
    id: "13",
    service_name: "Bed Sheet Ironing",
    category: "Household",
    unit: 1,
    price: "$40",
    type: "Per Item",
    description: "Flat ironing for large bed sheets",
  },
  {
    id: "14",
    service_name: "Formal Wear Wash",
    category: "Gents Wear",
    unit: 1,
    price: "$65",
    type: "Per Set",
    description: "Wash for shirt and trouser set",
  },
  {
    id: "15",
    service_name: "Silk Dress Dry Clean",
    category: "Lady's Wear",
    unit: 1,
    price: "$220",
    type: "Per Piece",
    description: "Gentle dry clean for silk dresses",
  },
  {
    id: "16",
    service_name: "School Uniform Wash",
    category: "Kids Wear",
    unit: 1,
    price: "$40",
    type: "Per Set",
    description: "Standard wash for school uniforms",
  },
  {
    id: "17",
    service_name: "Quilt Cleaning",
    category: "Household",
    unit: 1,
    price: "$300",
    type: "Per Quilt",
    description: "Deep cleaning for heavy quilts",
  },
  {
    id: "18",
    service_name: "Towel Wash & Iron",
    category: "Household",
    unit: 4,
    price: "$25",
    type: "Per Towel",
    description: "Soft wash and iron for towels",
  },
  {
    id: "19",
    service_name: "Lehenga Dry Clean",
    category: "Lady's Wear",
    unit: 1,
    price: "$350",
    type: "Per Piece",
    description: "Premium dry clean for heavy lehengas",
  },
  {
    id: "20",
    service_name: "Winter Jacket Wash",
    category: "Gents Wear",
    unit: 1,
    price: "$200",
    type: "Per Jacket",
    description: "Deep cleaning for wool jackets",
  },
];

export const customerColumns = [
  { field: "name", label: "Name", filter: true },
  // { field: 'email', label: 'Email' },
  { field: "phone_number", label: "Phone" },
  {
    field: "order_status",
    label: "Tag",
    filter: true,
    options: [
      { label: "VIP", value: "VIP" },
      { label: "NEW", value: "NEW" },
      { label: "AT RISK", value: "AT_RISK" },
    ],
  },
  { field: "totalOrders", label: "Total Orders",filter: true },
  { field: "date", label: "Last Order" ,filter: true },
  { field: "action", label: "Actions" },
];

export const customerRows = [
  {
    id: "1",
    tags: "Premium",
    customer_name: "Rohit Sharma",
    contact: "+91-9876543210",
    email: "rohit@example.com",
    total_order: 12,
    last_order_date: "2024-06-10",
  },
  {
    id: "2",
    tags: "New",
    customer_name: "Anjali Verma",
    contact: "+91-9123456780",
    email: "anjali@example.com",
    total_order: 1,
    last_order_date: "2025-06-19",
  },
  {
    id: "3",
    tags: "Frequent",
    customer_name: "Karan Mehta",
    contact: "+91-9900112233",
    email: "karan.mehta@example.com",
    total_order: 8,
    last_order_date: "2025-05-30",
  },
  {
    id: "4",
    tags: "Premium",
    customer_name: "Deepika Singh",
    contact: "+91-8080808080",
    email: "deepika@example.com",
    total_order: 15,
    last_order_date: "2025-06-01",
  },
  {
    id: "5",
    tags: "Inactive",
    customer_name: "Ajay Kumar",
    contact: "+91-7777000000",
    email: "ajay.k@example.com",
    total_order: 4,
    last_order_date: "2025-04-15",
  },
  {
    id: "6",
    tags: "Frequent",
    customer_name: "Neha Patil",
    contact: "+91-9823412341",
    email: "neha.patil@example.com",
    total_order: 10,
    last_order_date: "2025-06-14",
  },
  {
    id: "7",
    tags: "New",
    customer_name: "Suresh Raina",
    contact: "+91-9012345678",
    email: "suresh.r@example.com",
    total_order: 2,
    last_order_date: "2025-06-20",
  },
  {
    id: "8",
    tags: "VIP",
    customer_name: "Priya Rao",
    contact: "+91-8888999900",
    email: "priya.rao@example.com",
    total_order: 20,
    last_order_date: "2025-06-18",
  },
  {
    id: "9",
    tags: "Inactive",
    customer_name: "Rahul Deshmukh",
    contact: "+91-7001234567",
    email: "rahul.d@example.com",
    total_order: 3,
    last_order_date: "2025-03-27",
  },
  {
    id: "10",
    tags: "Premium",
    customer_name: "Shruti Nair",
    contact: "+91-9112233445",
    email: "shruti.nair@example.com",
    total_order: 14,
    last_order_date: "2025-06-15",
  },
];

export const orderColumns = [
  { field: "order_id", label: "Order ID" },
  {
    field: "customer_name",
    label: "Customer Name",
    filter: true,
    width: "180px",
  },
  { field: "date", label: "Date", filter: true, width: "150px" },
  { field: "address", label: "Address", width: "300px" },
  { field: "contact", label: "Phone Number", width: "150px" },
  {
    field: "order_status",
    label: "Order Status",
    filter: true,
    options: [
      { label: "Confirmed", value: "Confirmed" },
      { label: "Pickup Scheduled", value: "Pickup Scheduled" },
      { label: "Pickup Rescheduled", value: "Pickup Rescheduled" },
      { label: "Pickup Confirmed", value: "Pickup Confirmed" },
      { label: "Out for Pickup", value: "Out for Pickup" },
      { label: "Picked Up", value: "Picked Up" },
      { label: "At Store", value: "At Store" },
      { label: "Processing", value: "Processing" },
      { label: "Delayed", value: "Delayed" },
      { label: "Ready for Delivery", value: "Ready for Delivery" },
      { label: "Out for Delivery", value: "Out for Delivery" },
      { label: "Delivered", value: "Delivered" },
    ],
  },
  { field: "action", label: "Action" },
];

export const orderStatusOptions = [
  "Confirmed",
  "Pickup Scheduled",
  "Pickup Rescheduled",
  "Pickup Confirmed",
  "Out for Pickup",
  "Picked Up",
  "At Store",
  "Processing",
  "Ready for Delivery",
  "Out for Delivery",
  "Delivered",
  "Delayed",
];

export const orderRows = [
  {
    id: "1",
    order_id: "ORD001",
    customer_name: "Rohit Sharma",
    date: "2025-06-18",
    address: "Plot 12, Andheri West, Mumbai",
    contact: "+91-9876543210",
    order_status: "Out for delivery",
  },
  {
    id: "2",
    order_id: "ORD002",
    customer_name: "Anjali Verma",
    date: "2025-06-17",
    address: "Sector 22, Noida",
    contact: "+91-9123456780",
    order_status: "In progress",
  },
  {
    id: "3",
    order_id: "ORD003",
    customer_name: "Karan Mehta",
    date: "2025-06-15",
    address: "Banjara Hills, Hyderabad",
    contact: "+91-9900112233",
    order_status: "Ready",
  },
  {
    id: "4",
    order_id: "ORD004",
    customer_name: "Deepika Singh",
    date: "2025-06-14",
    address: "Park Street, Kolkata",
    contact: "+91-8080808080",
    order_status: "In Progress",
  },
  {
    id: "5",
    order_id: "ORD005",
    customer_name: "Ajay Kumar",
    date: "2025-06-12",
    address: "MG Road, Bengaluru",
    contact: "+91-7777000000",
    order_status: "Recieved",
  },
  {
    id: "6",
    order_id: "ORD006",
    customer_name: "Neha Patil",
    date: "2025-06-10",
    address: "Kothrud, Pune",
    contact: "+91-9823412341",
    order_status: "Out for Delivery",
  },
  {
    id: "7",
    order_id: "ORD007",
    customer_name: "Suresh Raina",
    date: "2025-06-09",
    address: "Gandhinagar, Gujarat",
    contact: "+91-9012345678",
    order_status: "In progress",
  },
  {
    id: "8",
    order_id: "ORD008",
    customer_name: "Priya Rao",
    date: "2025-06-08",
    address: "Anna Nagar, Chennai",
    contact: "+91-8888999900",
    order_status: "Recieved",
  },
  {
    id: "9",
    order_id: "ORD009",
    customer_name: "Rahul Deshmukh",
    date: "2025-06-06",
    address: "Civil Lines, Nagpur",
    contact: "+91-7001234567",
    order_status: "In Progress",
  },
  {
    id: "10",
    order_id: "ORD010",
    customer_name: "Shruti Nair",
    date: "2025-06-05",
    address: "Marine Drive, Mumbai",
    contact: "+91-9112233445",
    order_status: "Ready",
  },
];

export const operationalColumns = [
  { field: "day", label: "Day" },
  { field: "open_time", label: "Open Time" },
  { field: "close_time", label: "Close Time" },
  { field: "order_status", label: "Status" },
  // { field: 'action', label: 'Action' }
];

export const operationalRows = [
  {
    day: "Monday",
    open_time: dayjs().hour(9).minute(0),
    close_time: dayjs().hour(17).minute(0),
    order_status: "Open",
  },
  {
    day: "Tuesday",
    open_time: dayjs().hour(9).minute(0),
    close_time: dayjs().hour(17).minute(0),
    order_status: "Open",
  },
  {
    day: "Wednesday",
    open_time: dayjs().hour(9).minute(0),
    close_time: dayjs().hour(17).minute(0),
    order_status: "Open",
  },
  {
    day: "Thursday",
    open_time: dayjs().hour(9).minute(0),
    close_time: dayjs().hour(17).minute(0),
    order_status: "Open",
  },
  {
    day: "Friday",
    open_time: dayjs().hour(9).minute(0),
    close_time: dayjs().hour(17).minute(0),
    order_status: "Open",
  },
  {
    day: "Saturday",
    open_time: null,
    close_time: null,
    order_status: "Closed",
  },
  { day: "Sunday", open_time: null, close_time: null, order_status: "Closed" },
];

export const blackoutColumn = [
  { field: "date", label: "Date" },
  { field: "open_time", label: "Open Time" },
  { field: "close_time", label: "Close Time" },
  { field: "override", label: "Override" },
  { field: "order_status", label: "Order Status" },
  // { field: 'action', label: 'Action' }
];

export const campaignColumns = [
  { field: "name", label: "Name" },
  { field: "code", label: "Code" },
  { field: "start_date", label: "Start Date" },
  { field: "end_date", label: "End date" },
  { field: "promotionType", label: "Promotion Type" },
  // { field: "type", label: "Type" },
  { field: "customerTag", label: "Customer Tag" },
  { field: "service_type", label: "Services" },
  { field: "minimum_order_count", label: "Order Count" },
  { field: "order_status", label: "Order Status",width: "180px" },
  { field: "action", label: "Action" },
];

export const campaignRows = [
  {
    id: 1,
    name: "Summer Bonanza",
    code: "SUMMER24",
    start_date: "2025-06-01",
    end_date: "2025-06-30",
    order_status: "Active",
  },
  {
    id: 2,
    name: "Monsoon Magic",
    code: "RAINY25",
    start_date: "2025-07-01",
    end_date: "2025-07-15",
    order_status: "Inactive",
  },
  {
    id: 3,
    name: "Flash Sale",
    code: "FLASH75",
    start_date: "2025-06-25",
    end_date: "2025-06-27",
    order_status: "Ended",
  },
  {
    id: 4,
    name: "New User Offer",
    code: "WELCOME50",
    start_date: "2025-05-01",
    end_date: "2025-12-31",
    order_status: "Active",
  },
  {
    id: 5,
    name: "Independence Day Promo",
    code: "FREEDOM20",
    start_date: "2025-08-10",
    end_date: "2025-08-15",
    order_status: "Pause",
  },
  {
    id: 6,
    name: "Summer Bonanza",
    code: "SUMMER24",
    start_date: "2025-06-01",
    end_date: "2025-06-30",
    order_status: "Active",
  },
  {
    id: 7,
    name: "Monsoon Magic",
    code: "RAINY25",
    start_date: "2025-07-01",
    end_date: "2025-07-15",
    order_status: "Inactive",
  },
  {
    id: 8,
    name: "Flash Sale",
    code: "FLASH75",
    start_date: "2025-06-25",
    end_date: "2025-06-27",
    order_status: "Ended",
  },
  {
    id: 9,
    name: "New User Offer",
    code: "WELCOME50",
    start_date: "2025-05-01",
    end_date: "2025-12-31",
    order_status: "Active",
  },
  {
    id: 10,
    name: "Independence Day Promo",
    code: "FREEDOM20",
    start_date: "2025-08-10",
    end_date: "2025-08-15",
    order_status: "Pause",
  },
];

export const inventoryColumns = [
  { field: "name", label: "Item Name" },
  { field: "sku", label: "Item Code" },
  { field: "price", label: "Unit Price" },
  { field: "itemQuantity", label: "Quantity" },
  { field: "category_name", label: "Category" },
  { field: "service", label: "Applicable Category" },
  { field: "itemDescription", label: "Description" },
  { field: "action", label: "Action" },
];

export const inventoryRows = [
  {
    id: 1,
    name: "Cotton Shirt",
    sku: "CSHIRT001",
    unit: "piece",
    starting_quantity: 150,
    current_stock: 120,
  },
  {
    id: 2,
    name: "Denim Jeans",
    sku: "DJEANS002",
    unit: "piece",
    starting_quantity: 100,
    current_stock: 75,
  },
  {
    id: 3,
    name: "Woolen Jacket",
    sku: "WJACK003",
    unit: "piece",
    starting_quantity: 50,
    current_stock: 20,
  },
  {
    id: 4,
    name: "Silk Saree",
    sku: "SSAREE004",
    unit: "piece",
    starting_quantity: 80,
    current_stock: 80,
  },
  {
    id: 5,
    name: "Cotton Bedsheet",
    sku: "CBEDSHEET005",
    unit: "set",
    starting_quantity: 200,
    current_stock: 160,
  },
];


export const serviceFormat = (value) => {
  switch (value) {
    case "DRYCLEANING" :
      return "Dry Cleaning";
    case "TAILORING":
      return "Tailoring";
    case "WASH_N_FOLD":
      return "Wash & Fold";
    default:
      return value;
  }
};